import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=5b0bd867&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0bd867')) {
      api.createRecord('5b0bd867', component.options)
    } else {
      api.reload('5b0bd867', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=5b0bd867&", function () {
      api.rerender('5b0bd867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/switch/src/switch.vue"
export default component.exports